<template>
  <div id="root">
    <router-view></router-view>
  </div>
</template>

<script>
  export default {
    name: 'app'
  }
</script>


<style lang="scss">

  body {

    font-family: -apple-system, BlinkMacSystemFont, "Helvetica Neue", "ヒラギノ角ゴ ProN W3", Hiragino Kaku Gothic ProN, "Yu Gothic", YuGothic, Arial, "メイリオ", Meiryo, sans-serif;
    /*font-family: "ヒラギノ角ゴ ProN W3", Hiragino Kaku Gothic ProN, "Yu Gothic", YuGothic, Arial, "メイリオ", Meiryo, sans-serif;*/
    /*font-weight: 800;*/
    /*min-height: 100vh;*/
  }

  .bold {
    font-weight: 800;

    h1, h2, h3, h4, h5, h6 {
      /*margin-top: 0;*/
      /*margin-bottom: 2rem;*/
      font-weight: 800;
    }
  }



  #root {
    min-height: 100vh;
  }

</style>



// WEBPACK FOOTER //
// App.vue?09da33ac